const project = [
    {
        title: "Taşdelen Mahallesi'nde Komşularımızın Taleplerini Dinledik",
        image: require("./images/tasdelen/halkbulusmasi.png"),
        description: "Halk Günü Değil, Halkın Günü buluşmalarımız kapsamında Cemal Güngör Parkı Amfi Tiyatro alanında Taşdelenli komşularımızla bir araya geldik. Komşularımızın talep, istek, beklenti ve şikayetlerini tek tek not aldık. Sorunların yerinde tespiti ve hızlı çözümü için halkımızla buluşmaya ve Çekmeköy’ün her mahallesinde vatandaşlarımızı dinlemeye devam edeceğiz. Komşularımızın yanında olmaktan ve onların sesine kulak vermekten mutluluk duyuyoruz. Hep birlikte sorunların üstesinden geleceğiz!"
    },
]

export default project